import React, { useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router-dom";

import openSocket from "../../services/socket-io";

import {
  Button,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import Title from "../../components/Title";

import { DeleteOutline, Edit } from "@material-ui/icons";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

import BotModal from "../../components/BotModal";
import ConfirmationModal from "../../components/ConfirmationModal";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_BOTS") {
    const bots = action.payload;
    const newBots = [];

    bots.forEach((bot) => {
      const index = state.findIndex((b) => b.id === bot.id);
      if (index !== -1) {
        state[index] = bot;
      } else {
        newBots.push(bot);
      }
    });

    return [...state, ...newBots];
  }

  if (action.type === "UPDATE_BOTS") {
    const bot = action.payload;
    const index = state.findIndex((b) => b.id === bot.id);

    if (index !== -1) {
      state[index] = bot;
      return [...state];
    } else {
      return [bot, ...state];
    }
  }

  if (action.type === "DELETE_BOT") {
    const botId = action.payload;
    const index = state.findIndex((b) => b.id === botId);

    if (index !== -1) {
      state.splice(index, 1);
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const Bots = () => {
    const classes = useStyles();
  const history = useHistory();

  const [bots, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(false);

  const [botModalOpen, setBotModalOpen] = useState(false);
  const [selectedBot, setSelectedBot] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  // 📥 Cargar bots
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/bots");
        dispatch({ type: "LOAD_BOTS", payload: data });
        setLoading(false);
      } catch (err) {
        toastError(err);
        setLoading(false);
      }
    })();
  }, []);

  // 🔄 Socket realtime
  useEffect(() => {
    const socket = openSocket();

    socket.on("bot", (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_BOTS", payload: data.bot });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_BOT", payload: data.botId });
      }
    });

    return () => socket.disconnect();
  }, []);

  // 🧩 Handlers
  const handleOpenBotModal = () => {
    setSelectedBot(null);
    setBotModalOpen(true);
  };

  const handleCloseBotModal = () => {
    setSelectedBot(null);
    setBotModalOpen(false);
  };

  const handleEditBot = (bot) => {
    setSelectedBot(bot);
    setBotModalOpen(true);
  };

  const handleDeleteBot = async (botId) => {
    try {
      await api.delete(`/bots/${botId}`);
      toast.success("Bot eliminado correctamente");
    } catch (err) {
      toastError(err);
    }
    setSelectedBot(null);
  };

const handleOpenBotDetails = (botId) => {
  history.push(`/botsquerry?id=${botId}`);
};

  return (
    <MainContainer>
      <ConfirmationModal
        title={`Eliminar bot ${selectedBot?.name}?`}
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteBot(selectedBot.id)}
      >
        ¿Estás seguro?
      </ConfirmationModal>

      <BotModal
        open={botModalOpen}
        onClose={handleCloseBotModal}
        botId={selectedBot?.id}
      />

      <MainHeader>
        <Title>Bots / IA</Title>

        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenBotModal}
          >
            Crear Bot
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Activo</TableCell>
              <TableCell align="center">IA</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <>
              {bots.map((bot) => (
                <TableRow key={bot.id}>
                  <TableCell align="center">{bot.name}</TableCell>

                  <TableCell align="center">
                    {bot.isActive ? "Sí" : "No"}
                  </TableCell>

                  <TableCell align="center">
                    {bot.useAI ? "Sí" : "No"}
                  </TableCell>

                  <TableCell align="center">

<IconButton
  size="small"
  onClick={() => handleOpenBotDetails(bot.id)}
>
                     <SettingsOutlinedIcon />
                    </IconButton>


                    <IconButton onClick={() => handleEditBot(bot)}>
                      <Edit />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        setSelectedBot(bot);
                        setConfirmModalOpen(true);
                      }}
                    >
                      <DeleteOutline />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {loading && <TableRowSkeleton columns={4} />}
            </>
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default Bots;